import breadcrumbs from 'assets/img/breadcrumbs.svg';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import { IEditTeaserTotalSchedule } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import React, { useCallback, useState } from 'react';
import style from './AddButton.module.scss';

interface IAddButton {
	totalSchedules: IEditTeaserTotalSchedule[];
	setSchedules: (value: IEditTeaserTotalSchedule[]) => void;
}

const AddButton: React.FC<IAddButton> = ({ totalSchedules, setSchedules }) => {
	const [idCounter, setIdCounter] = useState<number>(1);

	const incrementId = () => {
		setIdCounter((prevState) => prevState + 1);
	};

	const handleClick = useCallback(() => {
		const newSchedule: IEditTeaserTotalSchedule = {
			id: String(idCounter),
			value: '',
		};
		setSchedules([...totalSchedules, newSchedule]);
		incrementId();
	}, [setSchedules, totalSchedules, idCounter]);

	return (
		<Button
			className={style.button}
			onClick={handleClick}
			iconPosition="post"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(AddButton);
